import React from 'react';
import PageBuilder from '../components/Pages/PageBuilder';

const PageBuilderContainer = () => {
  return (
    <>
      <div className="content_wrapper all_products_main">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageBuilder />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageBuilderContainer;
